var _defs, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 127.82 114.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#08877f;}.cls-4{fill:#09867f;}.cls-5{fill:#0b8680;}.cls-6{fill:#0c8580;}.cls-7{fill:#0e8580;}.cls-8{fill:#0f8481;}.cls-9{fill:#108481;}.cls-10{fill:#128381;}.cls-11{fill:#138382;}.cls-12{fill:#148282;}.cls-13{fill:#168282;}.cls-14{fill:#178183;}.cls-15{fill:#188183;}.cls-16{fill:#198083;}.cls-17{fill:#1b8084;}.cls-18{fill:#1c8084;}.cls-19{fill:#1d7f84;}.cls-20{fill:#1e7f85;}.cls-21{fill:#1f7e85;}.cls-22{fill:#217e85;}.cls-23{fill:#227d85;}.cls-24{fill:#237d86;}.cls-25{fill:#247c86;}.cls-26{fill:#257c86;}.cls-27{fill:#267c87;}.cls-28{fill:#277b87;}.cls-29{fill:#287b87;}.cls-30{fill:#297a87;}.cls-31{fill:#2a7a88;}.cls-32{fill:#2b7a88;}.cls-33{fill:#2c7988;}.cls-34{fill:#2d7988;}.cls-35{fill:#2e7989;}.cls-36{fill:#2f7889;}.cls-37{fill:#307889;}.cls-38{fill:#317889;}.cls-39{fill:#327789;}.cls-40{fill:#32778a;}.cls-41{fill:#33778a;}.cls-42{fill:#34778a;}.cls-43{fill:#35768a;}.cls-44{fill:#36768a;}.cls-45{fill:#36768b;}.cls-46{fill:#37758b;}.cls-47{fill:#38758b;}.cls-48{fill:#63ffe5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.5,
    y: 3.5,
    width: 120.82,
    height: 107.82,
    rx: 30.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.5,
    y: 3.5,
    width: 120.82,
    height: 107.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.14,57.41a227.66,227.66,0,0,1-5.2,49.1q-1.26,5.65-2.79,11v-5.22H5.67v5.22q-1.53-5.37-2.79-11a227.66,227.66,0,0,1-5.2-49.1,227.66,227.66,0,0,1,5.2-49.1q1.26-5.66,2.79-11V2.5H122.15V-2.71q1.53,5.36,2.79,11A227.66,227.66,0,0,1,130.14,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.76,57.41a222.4,222.4,0,0,1-5.1,48.08q-1.23,5.54-2.73,10.79v-4H6.88v4c-1-3.5-1.91-7.1-2.73-10.79A223,223,0,0,1-.94,57.41,223,223,0,0,1,4.15,9.33C5,5.64,5.89,2,6.88-1.46v4H120.93v-4q1.5,5.25,2.73,10.79A222.4,222.4,0,0,1,128.76,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.38,57.41a218.17,218.17,0,0,1-5,47.05q-1.2,5.43-2.67,10.57v-2.71H8.1V115q-1.47-5.15-2.68-10.57a218.19,218.19,0,0,1-5-47,218.19,218.19,0,0,1,5-47Q6.64,4.93,8.1-.21V2.5H119.72V-.21q1.47,5.15,2.67,10.57A218.17,218.17,0,0,1,127.38,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126,57.41a213.48,213.48,0,0,1-4.88,46c-.78,3.54-1.66,7-2.61,10.34v-1.46H9.31v1.46q-1.44-5-2.61-10.34a212.86,212.86,0,0,1-4.88-46,212.86,212.86,0,0,1,4.88-46Q7.87,6.07,9.31,1V2.5h109.2V1c.95,3.35,1.83,6.8,2.61,10.34A213.48,213.48,0,0,1,126,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M124.62,57.41a208.79,208.79,0,0,1-4.77,45q-1.16,5.19-2.56,10.1v-.2H10.52v.2c-.93-3.27-1.79-6.64-2.55-10.1a208.17,208.17,0,0,1-4.77-45A208.24,208.24,0,0,1,8,12.4C8.73,9,9.59,5.57,10.52,2.3v.2H117.29V2.3c.94,3.27,1.79,6.65,2.56,10.1A208.86,208.86,0,0,1,124.62,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M123.24,57.41a203.94,203.94,0,0,1-4.66,44q-1.12,5.07-2.5,9.88c-.46,1.6-.93,3.18-1.43,4.73v-3.68H13.17V116q-.75-2.32-1.43-4.73-1.38-4.8-2.5-9.88a203.94,203.94,0,0,1-4.66-44,204,204,0,0,1,4.66-44q1.13-5.07,2.5-9.88.67-2.4,1.43-4.73V2.5H114.65V-1.18c.5,1.55,1,3.13,1.43,4.73q1.36,4.8,2.5,9.88A204,204,0,0,1,123.24,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M121.86,57.41a199.25,199.25,0,0,1-4.55,43A159.19,159.19,0,0,1,112,119.12v-6.8H15.85v6.8a161.14,161.14,0,0,1-5.34-18.75A199.25,199.25,0,0,1,6,57.41a199.25,199.25,0,0,1,4.55-43A161.14,161.14,0,0,1,15.85-4.3V2.5H112V-4.3a159.19,159.19,0,0,1,5.35,18.75A199.25,199.25,0,0,1,121.86,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M120.48,57.41A194.56,194.56,0,0,1,116,99.35a158.47,158.47,0,0,1-5.22,18.3v-5.33H17v5.33a154.57,154.57,0,0,1-5.22-18.3A194.56,194.56,0,0,1,7.34,57.41a194.56,194.56,0,0,1,4.44-41.94A154.57,154.57,0,0,1,17-2.83V2.5h93.82V-2.83A158.47,158.47,0,0,1,116,15.47,194.56,194.56,0,0,1,120.48,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M119.1,57.41a189.3,189.3,0,0,1-4.34,40.92,151.88,151.88,0,0,1-5.08,17.85v-3.86H18.14v3.86a153.82,153.82,0,0,1-5.09-17.85A189.93,189.93,0,0,1,8.71,57.41,189.76,189.76,0,0,1,13.05,16.5,153.43,153.43,0,0,1,18.14-1.36V2.5h91.54V-1.36a151.5,151.5,0,0,1,5.08,17.86A189.14,189.14,0,0,1,119.1,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M117.72,57.41a184.45,184.45,0,0,1-4.23,39.89,146.88,146.88,0,0,1-5,17.41v-2.39H19.29v2.39a148.79,148.79,0,0,1-5-17.41,185.07,185.07,0,0,1-4.23-39.89,185.07,185.07,0,0,1,4.23-39.89,148.79,148.79,0,0,1,5-17.41V2.5h89.24V.11a146.88,146.88,0,0,1,5,17.41A184.45,184.45,0,0,1,117.72,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M116.34,57.41a180.38,180.38,0,0,1-4.12,38.87,146.12,146.12,0,0,1-4.83,17v-.92h-87v.92a142.27,142.27,0,0,1-4.83-17,179.74,179.74,0,0,1-4.13-38.87A179.74,179.74,0,0,1,15.6,18.54a142.27,142.27,0,0,1,4.83-17V2.5h87V1.58a146.12,146.12,0,0,1,4.83,17A180.38,180.38,0,0,1,116.34,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M115,57.41a175.69,175.69,0,0,1-4,37.85,139.55,139.55,0,0,1-4.71,16.51c-.91,2.59-1.9,5.09-2.94,7.49v-6.94H24.51v6.94q-1.56-3.6-2.94-7.49a141.48,141.48,0,0,1-4.7-16.51,175.05,175.05,0,0,1-4-37.85,175.12,175.12,0,0,1,4-37.85,141.48,141.48,0,0,1,4.7-16.51q1.38-3.88,2.94-7.49V2.5H103.3V-4.44c1,2.4,2,4.9,2.94,7.49A139.55,139.55,0,0,1,111,19.56,175.76,175.76,0,0,1,115,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M113.58,57.41a170.84,170.84,0,0,1-3.9,36.82,138.41,138.41,0,0,1-4.58,16.07c-.89,2.52-1.85,5-2.86,7.29v-5.27H25.58v5.27c-1-2.34-2-4.77-2.86-7.29a134.57,134.57,0,0,1-4.58-16.07,170.2,170.2,0,0,1-3.91-36.82,170.2,170.2,0,0,1,3.91-36.82A134.57,134.57,0,0,1,22.72,4.52C23.61,2,24.57-.43,25.58-2.77V2.5h76.66V-2.77c1,2.34,2,4.77,2.86,7.29a138.41,138.41,0,0,1,4.58,16.07A170.84,170.84,0,0,1,113.58,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M112.2,57.41a166.15,166.15,0,0,1-3.79,35.8A131.84,131.84,0,0,1,104,108.83q-1.29,3.67-2.78,7.09v-3.6H26.64v3.6q-1.47-3.42-2.78-7.09a133.77,133.77,0,0,1-4.45-15.62,166.14,166.14,0,0,1-3.8-35.8,166.14,166.14,0,0,1,3.8-35.8A133.77,133.77,0,0,1,23.86,6q1.3-3.67,2.78-7.08V2.5h74.53V-1.09Q102.66,2.32,104,6a131.84,131.84,0,0,1,4.46,15.62A166.15,166.15,0,0,1,112.2,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M110.82,57.41a161.46,161.46,0,0,1-3.68,34.78,129.87,129.87,0,0,1-4.33,15.18c-.84,2.37-1.74,4.67-2.7,6.87v-1.92H27.71v1.92c-1-2.2-1.86-4.5-2.7-6.87a129.87,129.87,0,0,1-4.33-15.18A161.45,161.45,0,0,1,17,57.41a161.45,161.45,0,0,1,3.69-34.78A129.14,129.14,0,0,1,25,7.46c.84-2.38,1.74-4.68,2.7-6.88V2.5h72.4V.58c1,2.2,1.86,4.5,2.7,6.88a129.14,129.14,0,0,1,4.33,15.17A161.46,161.46,0,0,1,110.82,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M109.44,57.41c0,24-5.09,45.63-13.33,61.32v-6.41H31.71v6.41C23.47,103,18.37,81.36,18.37,57.41s5.1-45.63,13.34-61.32V2.5h64.4V-3.91C104.35,11.78,109.44,33.46,109.44,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M108.06,57.41c0,23.22-4.94,44.24-12.93,59.46v-4.55H32.69v4.55c-8-15.22-12.94-36.24-12.94-59.46S24.7,13.17,32.69-2V2.5H95.13V-2C103.12,13.17,108.06,34.19,108.06,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M106.68,57.41c0,22.5-4.78,42.86-12.53,57.6v-2.69H33.66V115c-7.74-14.74-12.53-35.1-12.53-57.6S25.92,14.55,33.66-.19V2.5H94.15V-.19C101.9,14.55,106.68,34.91,106.68,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M105.3,57.41c0,21.77-4.63,41.48-12.12,55.75v-.84H34.64v.84c-7.49-14.27-12.13-34-12.13-55.75S27.15,15.93,34.64,1.66V2.5H93.18V1.66C100.67,15.93,105.3,35.64,105.3,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M103.92,57.41c0,21-4.48,40.1-11.72,53.89q-1.35,2.58-2.84,4.92v-3.9H38.45v3.9q-1.47-2.34-2.84-4.92C28.37,97.51,23.89,78.45,23.89,57.41s4.48-40.1,11.72-53.89Q37,.94,38.45-1.4V2.5H89.36V-1.4Q90.85.94,92.2,3.52C99.44,17.31,103.92,36.37,103.92,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M102.54,57.41c0,20.32-4.32,38.71-11.31,52a60.65,60.65,0,0,1-5.72,9v-6.1H42.31v6.1a59.84,59.84,0,0,1-5.72-9c-7-13.32-11.32-31.71-11.32-52s4.33-38.71,11.32-52a59.84,59.84,0,0,1,5.72-9V2.5h43.2V-3.6a60.65,60.65,0,0,1,5.72,9C98.22,18.7,102.54,37.09,102.54,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M101.16,57.41c0,19.59-4.17,37.33-10.91,50.17a58,58,0,0,1-5.51,8.67v-3.93H43.08v3.93a58.84,58.84,0,0,1-5.52-8.67C30.82,94.74,26.65,77,26.65,57.41S30.82,20.08,37.56,7.24a58.72,58.72,0,0,1,5.52-8.66V2.5H84.74V-1.42a57.88,57.88,0,0,1,5.51,8.66C97,20.08,101.16,37.82,101.16,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M99.78,57.41c0,18.87-4,36-10.5,48.31A56.89,56.89,0,0,1,84,114.07v-1.75H43.85v1.75a56.07,56.07,0,0,1-5.31-8.35C32.05,93.36,28,76.28,28,57.41s4-35.95,10.51-48.31A56.07,56.07,0,0,1,43.85.75V2.5H84V.75A56.89,56.89,0,0,1,89.28,9.1C95.77,21.46,99.78,38.54,99.78,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M98.4,57.41c0,18.14-3.86,34.57-10.1,46.45a44.42,44.42,0,0,1-11,14.08v-5.62H50.48v5.62a44.28,44.28,0,0,1-11-14.08C33.27,92,29.41,75.55,29.41,57.41S33.27,22.84,39.52,11a44.28,44.28,0,0,1,11-14.08V2.5H77.34V-3.12A44.42,44.42,0,0,1,88.3,11C94.54,22.84,98.4,39.27,98.4,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M97,57.41c0,17.42-3.7,33.18-9.7,44.6A42.63,42.63,0,0,1,76.8,115.52v-3.2H51v3.2A42.8,42.8,0,0,1,40.49,102c-6-11.42-9.7-27.18-9.7-44.6s3.71-33.18,9.7-44.6A42.8,42.8,0,0,1,51-.7V2.5H76.8V-.7A42.63,42.63,0,0,1,87.32,12.81C93.32,24.23,97,40,97,57.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 63.91,
    cy: 57.41,
    rx: 31.74,
    ry: 60.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 63.91,
    cy: 57.41,
    rx: 30.36,
    ry: 57.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 63.91,
    cy: 57.41,
    rx: 28.98,
    ry: 55.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 63.91,
    cy: 57.41,
    rx: 27.6,
    ry: 52.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 63.91,
    cy: 57.41,
    rx: 26.22,
    ry: 49.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 63.91,
    cy: 57.41,
    rx: 24.84,
    ry: 47.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 63.91,
    cy: 57.41,
    rx: 23.46,
    ry: 44.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 63.91,
    cy: 57.41,
    rx: 22.08,
    ry: 42.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 63.91,
    cy: 57.41,
    rx: 20.7,
    ry: 39.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-37",
    cx: 63.91,
    cy: 57.41,
    rx: 19.32,
    ry: 36.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-38",
    cx: 63.91,
    cy: 57.41,
    rx: 17.94,
    ry: 34.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 63.91,
    cy: 57.41,
    rx: 16.56,
    ry: 31.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 63.91,
    cy: 57.41,
    rx: 15.18,
    ry: 28.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 63.91,
    cy: 57.41,
    rx: 13.8,
    ry: 26.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-42",
    cx: 63.91,
    cy: 57.41,
    rx: 12.42,
    ry: 23.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 63.91,
    cy: 57.41,
    rx: 11.04,
    ry: 21.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 63.91,
    cy: 57.41,
    rx: 9.66,
    ry: 18.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-44",
    cx: 63.91,
    cy: 57.41,
    rx: 8.28,
    ry: 15.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-45",
    cx: 63.91,
    cy: 57.41,
    rx: 6.9,
    ry: 13.14
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-46",
    cx: 63.91,
    cy: 57.41,
    rx: 5.52,
    ry: 10.51
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-46",
    cx: 63.91,
    cy: 57.41,
    rx: 4.14,
    ry: 7.88
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-47",
    cx: 63.91,
    cy: 57.41,
    rx: 2.76,
    ry: 5.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-47",
    cx: 63.91,
    cy: 57.41,
    rx: 1.38,
    ry: 2.63
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M94.21,7a26.64,26.64,0,0,1,26.61,26.6V81.22a26.64,26.64,0,0,1-26.61,26.6H33.6A26.63,26.63,0,0,1,7,81.22V33.6A26.63,26.63,0,0,1,33.6,7H94.21m0-7H33.6A33.6,33.6,0,0,0,0,33.6V81.22a33.6,33.6,0,0,0,33.6,33.6H94.21a33.6,33.6,0,0,0,33.61-33.6V33.6A33.6,33.6,0,0,0,94.21,0Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M82.15,68.19q0,7.84-4.68,12.38T65.15,85.11q-6.69,0-10.9-2.52a11.29,11.29,0,0,1-5.37-7.34l5.69-3.1a14.91,14.91,0,0,0,4.14,5.07,10.64,10.64,0,0,0,6.23,1.55,9.83,9.83,0,0,0,7.23-2.59c1.76-1.73,2.63-4.39,2.63-8s-.83-6.26-2.48-7.85S68.25,58,65.08,58H52.48V34H80.13v6.77H58.82V51.63h6.26q8.36,0,12.71,4.28T82.15,68.19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.740b8479fd6dda1972e45a57ba1d67ae.svg";
export { ForwardRef as ReactComponent };